import { type IconProps, Stroke } from "./base";

/** Arrows and chevrons: where a control leads, or what it opens. */

export function ChevronRightIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M9 6l6 6-6 6" />
        </Stroke>
    );
}

export function ChevronDownIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M6 9l6 6 6-6" />
        </Stroke>
    );
}

export function ArrowUpRightIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M7 17L17 7M8 7h9v9" />
        </Stroke>
    );
}

export function ArrowRightIcon({ strokeWidth = 2.4, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M5 12h14M13 6l6 6-6 6" />
        </Stroke>
    );
}

/** Open the drawer's posting as its own page. */
export function ExpandIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" />
        </Stroke>
    );
}
